import { multiplyBy } from './multiply-by.helper';

export const fractionToPercent = (target: number | null | undefined): number | undefined => multiplyBy(target, 100);
